import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-widget-tensiometre',
    templateUrl: './tensiometre.component.html',
    styleUrls: ['./tensiometre.component.scss']
})
export class TensiometreComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }

}
